import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"; // Correct import
import ScrollToTop from "./component/scrollToTop/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from "react-ga4";
// Import your components/pages
import DigitalAgency from "./pages/DigitalAgency";
import CreativeAgency from "./pages/CreativeAgency";
import PersonalPortfolio from "./pages/PersonalPortfolio";
import HomeStartup from "./pages/HomeStartup";
import CorporateAgency from "./pages/CorporateAgency";
import BlogGridView from "./pages/BlogGrid";
import BlogCategory from "./pages/Category";
import BlogArchive from "./pages/Archive";
import BlogDetails from "./pages/BlogDetails";
import ServiceOne from "./pages/ServiceOne";
import ServiceTwo from "./pages/ServiceTwo";
import ServiceDetails from "./pages/ServiceDetails";
import ProjectGridOne from "./pages/ProjectGridOne";
import ProjectGridTwo from "./pages/ProjectGridTwo";
import ProjectGridThree from "./pages/ProjectGridThree";
import ProjectGridFour from "./pages/ProjectGridFour";
import ProjectGridFive from "./pages/ProjectGridFive";
import ProjectDetails from "./pages/ProjectDetails";
import AboutUs from "./pages/AboutUs";
import OurOffice from "./pages/OurOffice";
import OurClients from "./pages/OurClients";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import CaseStudy from "./pages/CaseStudy";
import CaseDetails from "./pages/CaseStudyDetails";
import Testimonials from "./pages/Testimonials";
import PricingTable from "./pages/PricingTable";
import Typography from "./pages/Typography";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ErrorPage from "./pages/404";
import ComingSoon from "./pages/ComingSoon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Resource from "./pages/Resource";
import "./assets/scss/app.scss";
import InstructorLogin from "./pages/InstructorLogin";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoutes from "./ProtectedRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";

import MentorLogin from "./pages/MentorLogin";
import ForRecruiters from "./pages/ForRecruiters";
import PostJob from "./component/forrecruiters/PostJob";
import DreamCareer from "./pages/DreamCareer";
import SEO from "./common/SEO";
import RecruitersLogin from "./pages/RecruitersLogin";
import OrganizationLogin from "./pages/OrganizationLogin";
import Thankyou from "./pages/Thankyou";
import Individuals from "./pages/Individuals";
import Institutions from "./pages/Institutions";
import FeedbackForm from "./pages/FeedbackForm";
import ForgotPassword from "./pages/ForgotPassword";
import PaymentPage from "./pages/SignupProcess/Payment";
import PriceDiscussion from "./pages/PriceDiscussion";
import axios from "axios";
import { initEventLogger } from "./initEventLogger";
import API_BASE_URL from "./common/config";
import UniversityLogin from "./University/UniversityLogin";
import UniversityStudentLogin from "./University/UniversityStudentLogin";
import ParentLogin from "./University/ParentLogin";
import ParentDashboard from "./parentDashboard/ParentDashboard";
import University from "./pages/University";

const App = () => {
  // Function to check session and logout if expired
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const stopLogger = initEventLogger({
      flushInterval: 500,
      events: ["click", "input", "keydown", "focus", "beforeunload"],
      onFlush: (events) => {
        console.log("Flushed events:", events);
        axios.post(`${API_BASE_URL}/log`, {
          page: window.location.pathname,
          events,
          userId,
        });
      },
    });

    return () => {
      if (typeof stopLogger === "function") {
        stopLogger();
      }
    };
  }, []);

  function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);

    return null; // This component doesn't render anything
  }

  const checkSession = () => {
    const sessionData = localStorage.getItem("session");
    if (sessionData) {
      const { expiry } = JSON.parse(sessionData);
      if (Date.now() > expiry) {
        logoutUser();
      }
    }
  };

  // Function to reset session timer on user activity
  const resetSessionTimer = () => {
    const sessionData = {
      expiry: Date.now() + 15 * 60 * 1000, // 15 minutes from now
    };
    localStorage.setItem("session", JSON.stringify(sessionData));
  };

  // Function to handle user logout
  const logoutUser = () => {
    localStorage.removeItem("session");
    localStorage.removeItem("userId");
    localStorage.removeItem("sUserid");
    alert("Session expired due to inactivity. Please log in again.");
    window.location.href = "/login";
  };

  useEffect(() => {
    // Check if user is authenticated
    const isAuthenticated =
      localStorage.getItem("userId") || localStorage.getItem("sUserid");

    if (isAuthenticated) {
      // Initialize session if not exists
      if (!localStorage.getItem("session")) {
        resetSessionTimer();
      }

      // Check session status every minute
      const sessionChecker = setInterval(checkSession, 60000);

      // Setup event listeners for user activity
      const activityEvents = [
        "mousedown",
        "mousemove",
        "keypress",

        "touchstart",
      ];

      const activityListener = () => {
        resetSessionTimer();
      };

      // Add all event listeners
      activityEvents.forEach((event) => {
        document.addEventListener(event, activityListener);
      });

      // Cleanup on component unmount
      return () => {
        clearInterval(sessionChecker);
        activityEvents.forEach((event) => {
          document.removeEventListener(event, activityListener);
        });
      };
    }
  }, []);

  window.onerror = function (message, source, lineno, colno, error) {
    if (message === "Script error.") {
      return true; // Suppress the error from being logged
    }
  };

  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }

  const isAuthenticated = localStorage.getItem("userId");
  const isAuthenticat = localStorage.getItem("sUserid");

  return (
    <BrowserRouter>
      <SEO />
      <ScrollToTop>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<CorporateAgency />} />
          <Route path="/blog-grid" element={<BlogGridView />} />
          <Route path="/category/:slug" element={<BlogCategory />} />
          <Route path="/archive/:slug" element={<BlogArchive />} />
          <Route path="/blog-details/:id" element={<BlogDetails />} />
          <Route path="/service-one" element={<ServiceOne />} />
          <Route path="/service-two" element={<ServiceTwo />} />
          <Route path="/service-details/:slug" element={<ServiceDetails />} />
          <Route path="/project-grid-one" element={<ProjectGridOne />} />
          <Route path="/project-grid-two" element={<ProjectGridTwo />} />
          <Route path="/project-grid-three" element={<ProjectGridThree />} />
          <Route path="/project-width-one" element={<ProjectGridFour />} />
          <Route path="/project-width-two" element={<ProjectGridFive />} />
          <Route path="/project-details/:slug" element={<ProjectDetails />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/our-office" element={<OurOffice />} />
          <Route path="/our-clients" element={<OurClients />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team-details/:slug" element={<TeamDetails />} />
          <Route path="/case-study" element={<CaseStudy />} />
          <Route path="/case-details/:slug" element={<CaseDetails />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/dream-career" element={<DreamCareer />} />
          <Route path="/subscription" element={<PricingTable />} />
          <Route path="/for-recruiters" element={<ForRecruiters />} />
          <Route path="/individuals" element={<Individuals />} />
          <Route path="/institutions" element={<Institutions />} />
          <Route path="/post-job" element={<PostJob />} />
          <Route path="/typography" element={<Typography />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/*" element={<ErrorPage />} />
          <Route path="/thank-you" element={<Thankyou />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-use" element={<TermsOfUse />} />
          <Route path="/resource" element={<Resource />} />
          <Route path="/university" element={<University />} />

          {/* dashboard routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            element={<ProtectedRoutes isAuthenticat={isAuthenticat} />}
          ></Route>
          <Route
            element={<ProtectedRoutes isAuthenticat={isAuthenticat} />}
          ></Route>

          {/* Nitin */}
          <Route path="/instructor-login" element={<InstructorLogin />} />
          <Route path="/mentor-login" element={<MentorLogin />} />
          <Route
            element={<PrivateRoute isAuthenticated={isAuthenticated} />}
          ></Route>

          <Route
            element={<PrivateRoute isAuthenticated={isAuthenticated} />}
          ></Route>

          <Route path="/recruiterslogin" element={<RecruitersLogin />} />
          <Route path="/organizationlogin" element={<OrganizationLogin />} />

          <Route path="/feedback" element={<FeedbackForm />} />
          <Route path="/forget-password" element={<ForgotPassword />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/price-discussion" element={<PriceDiscussion />} />
          <Route path="/university-login" element={<UniversityLogin />} />
          <Route
            path="/university-student-login"
            element={<UniversityStudentLogin />}
          />
          <Route path="/parent-login" element={<ParentLogin />} />
          <Route path="/parent-dashboard" element={<ParentDashboard />} />
        </Routes>
        <ToastContainer />
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default App;
